import { id, basic } from "../fragments/resource";

export const listUnitItems = /* GraphQL */ `
  query ListUnitItems($input: ListResourcesByIdThenSkInput!) {
    listUnitItems(input: $input) {
      items {
        id
        sk
        resource {
          createdAt
          id
          idInc
          isDeleted
          maturity
          name
          sk
          updatedAt
        }
      }
      nextToken
    }
  }
`;

export const listItemUnits = /* GraphQL */ `
  query ListItemUnits($input: ListResourcesByIdThenSkInput!) {
    listItemUnits(input: $input) {
      items {
        id
        sk
        resourceId
      }
      nextToken
    }
  }
`;

export const listItemUnitsWithName = /* GraphQL */ `
  query ListItemUnits($input: ListResourcesByIdThenSkInput!) {
    listItemUnits(input: $input) {
      items {
        id
        sk
        resourceId
        resource {
          id
          sk
          name
        }
      }
      nextToken
    }
  }
`;

export const attachItemsToUnit = /* GraphQL */ `
  mutation AttachItemsToUnit($input: [GenericRelationshipInput!]!) {
    attachItemsToUnit(input: $input) {
      id
      sk
    }
  }
`;

export const detachItemsFromUnit = /* GraphQL */ `
  mutation DetachItemsFromUnit($input: [GenericRelationshipInput!]!) {
    detachItemsFromUnit(input: $input) {
      id
      sk
    }
  }
`;

export const listUnitExams = /* GraphQL */ `
  query ListUnitExams($input: ListResourcesByIdThenSkInput!) {
    listUnitExams(input: $input) {
      items {
        id
        sk
        resourceId
        resource {
          ${id}
          ${basic}
          isDeleted
        }
      }
      nextToken
    }
  }
`;

export const attachExamsToUnit = /* GraphQL */ `
  mutation AttachExamsToUnit($input: [GenericRelationshipInput!]!) {
    attachExamsToUnit(input: $input) {
      id
      sk
    }
  }
`;

export const detachExamsFromUnit = /* GraphQL */ `
  mutation DetachExamsFromUnit($input: [GenericRelationshipInput!]!) {
    detachExamsFromUnit(input: $input) {
      id
      sk
    }
  }
`;

export const listAnnotations = /* GraphQL */ `
  query ListAnnotations(
    $filter: SearchableResourceFilterInput
    $authorizationContext: AuthorizationContextInput
    $nextToken: String
  ) {
    search(
      filter: $filter
      authorizationContext: $authorizationContext
      nextToken: $nextToken
    ) {
      items {
        id
        sk
        creator {
          firstName
          lastName
        }
        content {
          body
        }
        tags {
          key
          value
        }
        resourceId
        resource {
          id
          sk
          name
          type
          data
          file {
            region
            bucket
            key
          }
        }
        createdAt
        bankId
        workspaceId
      }
      nextToken
    }
  }
`;

export const createAnnotation = /* GraphQL */ `
  mutation CreateAnnotation(
    $input: CreateAnnotationInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    createAnnotation(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
    }
  }
`;

export const updateAnnotation = /* GraphQL */ `
  mutation UpdateAnnotation(
    $input: UpdateAnnotationInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    updateAnnotation(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
    }
  }
`;

export const deleteAnnotation = /* GraphQL */ `
  mutation DeleteAnnotation(
    $input: DeleteAnnotationInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    deleteAnnotation(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
    }
  }
`;

export const listRevisionNotes = /* GraphQL */ `
  query ListRevisionNotes(
    $input: ListResourcesByIdThenSkInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    listRevisionNotes(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      items {
        id
        sk
      }
      nextToken
    }
  }
`;

export const createRevisionNote = /* GraphQL */ `
  mutation CreateRevisionNote(
    $input: CreateRevisionNoteInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    createRevisionNote(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
    }
  }
`;

export const deleteRevisionNote = /* GraphQL */ `
  mutation DeleteRevisionNote(
    $input: DeleteRevisionNoteInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    deleteRevisionNote(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
    }
  }
`;

const unitOrSubUnitFields = `
  activitiesIds {
    id
    sk
    data
    tags {
      key
      type
      value
    }
  }
  coverImage {
    region
    bucket
    key
  }
  data
  description
  name
  numberLabel
  objectives {
    id
    sk
    data
    tags {
      key
      value
    }
    objective {
      id
      sk
      type
      annotations {
        content
        label
      }
      content
      notes
      parentId
      scope
      sequence
      tags {
        key
        value
      }
      abbreviation
    }
  }
  resources {
    id
    sk
    data
    resource {
      id
      sk
      schemaVersion
      workspaceId
      type
      name
      maturity
      idInc
      file {
        region
        bucket
        key
      }
      workspace {
        id
        sk
        name
        schemaVersion
      }
    }
    tags {
      key
      value
    }
  }
  vocabulariesIds {
    id
    sk
    tags {
      key
      value
    }
  }
`;

export const getUnit = /* GraphQL */ `
  query GetUnit($input: ModelGetInput!) {
    getUnit(input: $input) {
      id
      sk
      schemaVersion
      workspaceId
      bankId
      courseId
      course {
        id
        sk
        workspaceId
        schemaVersion
        name
        resourcesIds {
          id
          sk
        }
        units {
          id
          sk
          tags {
            key
            type
            value
          }
          unit {
            id
            sk
            schemaVersion
            workspaceId
            name
            numberLabel
          }
        }
      }
      createdAt
      creator {
        id
        sk
        firstName
        lastName
      }
      creatorId
      grade
      language
      maturity
      notes
      sequence
      subject
      subUnits {
        id
        ${unitOrSubUnitFields}
      }
      type
      updatedAt
      ${unitOrSubUnitFields}
    }
  }
`;

// This is meant to be enough to show a unit in a list of units
export const getUnitSimple = /* GraphQL */ `
  query GetUnit($input: ModelGetInput!) {
    getUnit(input: $input) {
      id
      sk
      schemaVersion
      workspaceId
      bankId

      name
      createdAt
      updatedAt

      courseId
      course {
        id
        sk
        workspaceId
        schemaVersion
        name
      }
    }
  }
`;

export const resolveUnitVocabularies = /* GraphQL */ `
  query ResolveUnitVocabularies(
    $input: [GenericReferenceIdInput!]!
    $authorizationContext: AuthorizationContextInput
  ) {
    resolveUnitVocabularies(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      items {
        id
        sk
        tags {
          key
          value
        }
        vocabulary {
          id
          sk
          workspaceId
          schemaVersion

          createdAt
          updatedAt
          description
          grade
          name
          subject
          tags {
            key
            value
          }
        }
      }
    }
  }
`;
